<template>
  <woot-modal :show.sync="show" :on-close="onCancel" size="medium">
    <div class="h-auto overflow-auto flex flex-col mb-30 pb-10">
      <woot-modal-header
        :header-title="
          $t('COMPLAINT.EDIT_BULK_HEADER', { count: selectedComplaints.length })
        "
      />
      <div class="mt-4 px-8">
        <div class="gap-2 flex flex-row">
          <!-- <div class="w-[50%]">
            <label>
              <input
                class="checkbox pr-1"
                type="checkbox"
                v-model="prioritySelected"
              />
              Prioritas
            </label>
          </div> -->
          <div class="w-[50%]">
            <label>
              <input
                class="checkbox pr-1"
                type="checkbox"
                v-model="massSelected"
              />
              {{ $t('COMPLAINT.MASS_TYPE') }}
            </label>
          </div>
        </div>
        <div v-if="massSelected">
          <div class="w-full py-2">
            <label for="massComplaintInput" class="mb-2">{{
              $t('COMPLAINT.DESCRIPTION')
            }}</label>
            <input
              type="text"
              class="text mb-0"
              v-model="massComplaint"
              list="massComplaintOptionsList"
              id="massComplaintInput"
              :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.MASS_INPUT')"
            />
            <datalist id="massComplaintOptionsList">
              <option
                v-for="option in massComplaintOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </datalist>
          </div>
        </div>
        <div class="gap-2 flex flex-row">
          <div class="w-[100%]">
            <label class="mb-1">{{ $t('COMPLAINT.TABLE.STATUS_LABEL') }}</label>
            <select class="mb-0" v-model="statusSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CUSTOMER_DETAIL.CHOOSE_STATUS') }}
              </option>
              <option
                v-for="status in statuses"
                :key="status.key"
                :value="status.key"
              >
                {{ status.name }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="statusSelected === 4" class="gap-2 flex flex-row mt-2">
          <div class="w-full pt-2">
            <select class="mb-0" v-model="confirmSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CHOOSE_LABEL') }}
              </option>
              <option
                v-for="item in pendingStatusOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="gap-2 flex flex-row mt-2">
          <div class="w-[50%]">
            <label class="mb-2">{{ $t('COMPLAINT.CHOOSE_ISSUE') }}</label>
            <select :max-height="160" v-model="issueSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CHOOSE_ISSUE') }}
              </option>
              <option
                v-for="issue in issues"
                :key="issue.key"
                :value="issue.key"
              >
                {{ issue.name }}
              </option>
            </select>
          </div>
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_FROM') }}</label>
            <select :max-height="160" v-model="sourcesSelected">
              <option disabled value="">
                {{ $t('COMPLAINT.CUSTOMER_DETAIL.CHOOSE_SOURCE') }}
              </option>
              <option
                v-for="source in sources"
                :key="source.key"
                :value="source.key"
              >
                {{ source.name }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="issueSelected === 2">
          <label class="my-2">{{
            $t('COMPLAINT.CUSTOMER_DETAIL.DOWNTIME_RANGE')
          }}</label>
          <Datepicker
            v-model="customDateRange"
            range
            type="datetime"
            format="YYYY-MM-DD HH:mm"
            :confirm="true"
            :not-auto-close="false"
            :confirm-text="$t('COMPLAINT.CHOOSE_LABEL')"
            class="w-full"
            @change="onChangeRange"
          />
        </div>
        <div v-if="issueSelected === 8" class="flex mt-3">
          <div class="w-full">
            <input
              class="text"
              type="text"
              v-model="otherIssue"
              :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.OTHER_ISSUE_INPUT')"
            />
          </div>
        </div>
        <div class="gap-2 flex flex-row">
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_DATE') }} </label>
            <input type="date" v-model="currentDate" class="mb-0 datepicker" />
          </div>
          <div class="w-[50%]">
            <label class="mb-2"> {{ $t('COMPLAINT.COMPLAINT_TIME') }} </label>
            <input type="time" v-model="currentTime" class="mb-0 timepicker" />
          </div>
        </div>
        <div>
          <label class="my-2">{{ $t('COMPLAINT.DESCRIPTION') }}</label>
          <textarea
            v-model="complaintDesc"
            class="min-h-[5rem]"
            type="text"
            :placeholder="$t('COMPLAINT.INPUT_PLACEHOLDER.DESCRIPTION_INPUT')"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="self-start">{{ $t('COMPLAINT.ADD_PICTURE') }}</label>
          <input
            type="file"
            @change="onFileChange"
            multiple
            accept="image/*"
            class="my-3"
          />
        </div>
        <div class="flex flex-row justify-end gap-2 pt-5 px-0 w-full">
          <woot-button type="submit" @click="saveChanges">
            {{ $t('COMPLAINT.SAVE_BUTTON') }}</woot-button
          >
          <button class="button clear" @click.prevent="onCancel">
            {{ $t('COMPLAINT.CANCEL_BUTTON') }}
          </button>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Datepicker from 'vue2-datepicker';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      // prioritySelected: false,
      massComplaint: '',
      massComplaintOptions: [],
      massSelected: false,
      statusSelected: '',
      issueSelected: '',
      sourcesSelected: '',
      currentDate: '',
      currentTime: '',
      complaintDesc: '',
      otherIssue: '',
      confirmSelected: '',
      customDateRange: [],
      sources: [],
      issues: [],
      uploadedImages: [],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedComplaints: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    Datepicker,
  },

  computed: {
    ...mapGetters({
      complaintStatuses: 'complaints/getStatuses',
    }),
    statuses() {
      return this.complaintStatuses
        .filter(status => status.id != 1)
        .map(status => ({
          key: status.id,
          name: this.$t(`COMPLAINT.STATUS_NAME.${status.id}`),
        }));
    },
    pendingStatusOptions() {
      return [
        {
          value: 'Menunggu Konfirmasi Pelanggan',
          label: this.$t('COMPLAINT.PENDING_STATUS.CUSTOMER_CONFIRMATION'),
        },
        {
          value: 'Menunggu Hasil Teknisi',
          label: this.$t(
            'COMPLAINT.PENDING_STATUS.TECHNICAL_SUPPORT_CONFIRMATION'
          ),
        },
        {
          value: 'Menunggu Hasil NOC',
          label: this.$t('COMPLAINT.PENDING_STATUS.ENGINEER_CONFIRMATION'),
        },
      ];
    },
  },

  methods: {
    async saveChanges() {
      try {
        let utcStartDate = null;
        let utcEndDate = null;

        if (
          this.customDateRange &&
          this.customDateRange[0] &&
          this.customDateRange[1]
        ) {
          const startDate = new Date(this.customDateRange[0]);
          const endDate = new Date(this.customDateRange[1]);
          utcStartDate = startDate.toISOString();
          utcEndDate = endDate.toISOString();
        }
        const image = JSON.stringify(this.uploadedImages);

        let data = {
          // priority: this.prioritySelected ? 1 : 0,
          to_mass: this.massSelected,
          complaint_ids: this.selectedComplaints,
          complaint_date: this.currentDate ? this.currentDate : null,
          complaint_time: this.currentTime
            ? `${this.currentTime.split('T')}.000Z`
            : null,
          problem_id: this.issueSelected || null,
          status_id: this.statusSelected || null,
          description: this.complaintDesc || null,
          complaint_source_id: this.sourcesSelected || null,
          medias: image,
        };

        if (this.issueSelected === 8) {
          data.other_issue = this.otherIssue;
        }
        if (this.statusSelected === 4) {
          data.pending_status = this.confirmSelected;
        }
        if (this.statusSelected === 5) {
          data.completed_at = new Date().toISOString();
        }
        if (this.customDateRange) {
          data.offline_range_start_date = utcStartDate;
          data.offline_range_end_date = utcEndDate;
        }
        if (this.massSelected) {
          data.mass_complaint_description = this.massComplaint;
        }

        data = Object.fromEntries(
          Object.entries(data).filter(
            ([_, value]) => value !== null && value !== undefined
          )
        );

        await this.$store.dispatch('complaints/update', {
          id: data.complaint_ids,
          data,
        });

        this.$emit('complaint-updated');

        this.showAlert(this.$t('COMPLAINT.SUCCESS_UPDATE_COMPLAINT'));
        this.$emit('complaint-reset');
        this.$emit('cancel');
      } catch (error) {
        console.error('Error updateing complaint', error);
      }
    },
    onCancel() {
      this.$emit('complaint-reset');
      this.$emit('cancel');
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    onChangeRange(value) {
      this.customDateRange = value;
    },
    onFileChange(event) {
      const files = event.target.files;
      this.uploadedImages = [];
      const promises = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        promises.push(this.convertToBase64(file));
      }

      Promise.all(promises).then(base64Files => {
        this.uploadedImages = base64Files;
      });
    },
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = error => {
          reject(error);
        };
      });
    },
    async fetchIssues() {
      try {
        const response = await axios.get('/problems');
        this.issues = response.data.map(problem => ({
          key: problem.id,
          name: this.$t(`COMPLAINT.ISSUES.${problem.id}`),
        }));
      } catch (error) {
        console.error('Error fetching issues:', error);
      }
    },
    async fetchSources() {
      try {
        const response = await axios.get('/complaint_sources');
        this.sources = response.data.map(source => ({
          key: source.id,
          name: this.$t(`COMPLAINT.SOURCE.${source.id}`),
        }));
      } catch (error) {
        console.error('Error fetching issues:', error);
      }
    },
  },

  mounted() {
    this.$store.dispatch('complaints/fetchStatus');
    this.fetchIssues();
    this.fetchSources();
  },
};
</script>
